import { useEffectivePermissions } from '#pplx/frontend/apps/ask/organization/hooks/useEffectivePermissions.js';
import { useUserOrgData } from '#pplx/frontend/apps/ask/organization/hooks/useUserOrgData.js';
export const useAPIGroupSettingsEnabled = () => {
    const reason = 'use-api-group-settings-enabled';
    const { isLoading, isEnterprise } = useUserOrgData({ reason });
    const { permissions, isLoading: permsLoading } = useEffectivePermissions({
        reason,
        enabled: isEnterprise,
    });
    // Non-enterprise users always have API access.
    if (!isEnterprise) {
        return { loading: isLoading, value: !isLoading };
    }
    // Enterprise gates the API Platform tab on the user's effective
    // `org_api_access` grant so the tab matches the backend `pplx_api_enabled()`
    // check. Block while it resolves so the tab doesn't flash in then out.
    const loading = isLoading || permsLoading;
    return { loading, value: !loading && permissions.has('org_api_access') };
};
//# sourceMappingURL=useAPIGroupSettingsEnabled.js.map